

exports.__esModule = true;
exports.$UpdateShippingRoute = undefined;

require('./directive');

require('xo-address-components/src/address-normalization/route');

require('xo-address-components/src/add-address/directive');

require('../shipping-address/directive');

var _squid = require('squid');

var $UpdateShippingRoute = exports.$UpdateShippingRoute = _squid.$ComponentRoute.extend('$UpdateShippingRoute', {
    name: 'updateShipping',
    directive: 'xo-update-shipping',
    titleContent: 'addShipping.addAddress',
    trackingData: {
        fptiState: 'update_shipping',
        buzname: {
            'fullpage': {
                'pagename': '%::update_shipping',
                'pagename2': '%::update_shipping:member:hermes:',
                'version': 'member:%:'
            }
        }
    },
    loginRequired: true,
    children: [{
        name: '$AddressNormalizationRoute',
        attributes: {
            id: 'token',
            sidebar: 'sidebar',
            address: 'address',
            'done-fn': 'uponNormalization'
        }
    }]
});

angular.value("$UpdateShippingRoute", $UpdateShippingRoute);
_squid.$ComponentRoute;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-member-components/src/select-shipping/update-shipping/route.js
// module id = ../node_modules/xo-member-components/src/select-shipping/update-shipping/route.js
// module chunks = 0